import React from 'react';
import { observer } from 'mobx-react-lite';

import { useStore } from '@src/models';
import { Flex, Text } from 'src/kit';
import { Loader } from 'src/components';
import { JobInfoModal } from '@src/features/job';
import { JobCard } from '../molecules/JobCard';
import { useJobFeed } from '../hooks/useJobFeed';

export const JobsList = observer(({ getJobs }: { getJobs: (qs) => string }) => {
  const [selectedJob, setSelectedJob] = React.useState<any>(null);
  const { authStore } = useStore();
  const { ref, jobsList, error, isJobsFetched } = useJobFeed(getJobs, 'jobsList');

  if (error || (isJobsFetched && jobsList.length === 0)) {
    return (
      <Flex flexWrap="wrap" pb={70} justifyContent="center">
        <Text fontSize={16} fontWeight="light" color="textPrimary">
          No Jobs Found
        </Text>
      </Flex>
    );
  }
  return (
    <>
      {selectedJob && (
        <JobInfoModal isAuthorized={authStore.isAuthorized} job={selectedJob} onClose={() => setSelectedJob(null)} />
      )}
      <Flex flexWrap="wrap" pb={70} maxWidth={jobsList.length === 0 ? '870px' : 'initial'}>
        {Boolean(jobsList.length) && (
          <>
            {jobsList.map(job => (
              <React.Fragment key={job.id || job.ability_token}>
                <JobCard job={job} onClick={() => setSelectedJob(job)} />
              </React.Fragment>
            ))}
            {jobsList.length > 1 && <div ref={ref}></div>}
          </>
        )}

        {!error && !isJobsFetched && (
          <Flex justifyContent="center" width="100%">
            <Loader css={{ position: 'relative', height: '200px' }} />
          </Flex>
        )}
      </Flex>
      {/* {!error && !isJobsFetched && <Loader css={{ position: 'relative', height: '200px' }} />} */}
    </>
  );
});
